module.exports = __webpack_public_path__ + "img/warning.87058477.svg";